<template>
    <!--弹窗-->
    <el-dialog
        width="850px"
        title="排名更新情况"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form :inline="true">
            <el-form-item label="类目名称:" class="query-form-item">
                <el-input style="width: 150px;" clearable v-model="query.name" placeholder="请输入类目名称"
                          size="mini"></el-input>
            </el-form-item>
            <el-form-item label="国家: " class="query-form-item">
                <el-select
                    v-model="query.state"
                    ref="carrerSelect"
                    style="width: 150px;"
                    size="mini"
                    filterable
                >
                    <el-option
                        v-for="item in $common.us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-button type="primary" @click="getCategoryList" size="small">查询</el-button>

            <el-button type="primary" @click="addFunc" size="small">更新</el-button>

        </el-form>
        <el-table
            :row-key="getRowKeys"
            v-loading="loading"
            :data="list"
            class="table_content"
            size="mini"
            border
            height="400"
            style="width: 100%;">
            <el-table-column
                label="国家"
                :resizable="false"
                prop="state"
                align="center">
            </el-table-column>
            <el-table-column
                min-width="140"
                label="类目名"
                :resizable="true"
                prop="name"
                align="center">
            </el-table-column>
            <el-table-column
                min-width="140"
                label="中文描述"
                :resizable="true"
                prop="string"
                align="center">
            </el-table-column>
            <el-table-column
                min-width="140"
                label="状态"
                :resizable="true"
                align="center">

                <template slot-scope="scope">
                    <div>{{ scope.row.has_finish == 1 ? '已完成' : '' }}  <span style="color: red;font-weight: 700" v-show="scope.row.running_status || scope.row.running_status == 0">
                        ({{scope.row.running_status == 0 ? '新任务创建中' : scope.row.running_status == 1 ? '新任务更新排名中' : '新任务更新Asin详情中'}})</span></div>
                </template>
            </el-table-column>
        </el-table>

        <addUpdateRank :visible="showAddRootCategoryl" :subLibraryDetailInfo="subLibraryDetailInfo" @close-callback="closeCllback"></addUpdateRank>

    </el-dialog>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import addRootCategoryl from './addRootCategoryl.vue'
import addUpdateRank from './addUpdateRank.vue'
import {
    keepa_category_rank_statistics_task_list_index,
    keepa_keepa_root_category_index,
    keepa_keepa_root_category_list
} from '@/api/advAnalys/advAnalys.js'

export default {
    components: {addUpdateRank},
    data() {
        return {
            showAddRootCategoryl: false,
            list: [],
            loading: false,
            query: {
                state: '',
                name: ''
            },
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        subLibraryDetailInfo: {
            type: Object,
            default: {}
        },
    },
    watch: {
        'visible': {
            handler(val){
                val && this.getCategoryList()
            }
        }
    },
    methods: {
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getCategoryList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getCategoryList()
        },
        closeCllback(isshow) {
            this.showAddRootCategoryl = false
            isshow == true && this.getCategoryList()
        },
        getRowKeys(row) {
            return row.id
        },

        addFunc() {
            this.showAddRootCategoryl = true
        },
        getCategoryList() {
            this.loading = true
            let tempQuery = JSON.parse(JSON.stringify(this.query))
            if (tempQuery.state == '') {
                delete tempQuery.state
            }
            api.keepa_category_rank_statistics_task_list_index(tempQuery).then(res => {
                if (res.code === 0) {
                    this.$set(this, 'list', res.data)
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).finally(() => {
                this.loading = false
            })
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.loading = false
            this.$emit('close-callback', isshow)
        }
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;

    .shu {
        border-right: 1px solid #cecfd1;
    }

    .content-div {
        width: 50%;
        padding: 25px 20px;
    }

    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }

    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }

    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;

        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;

            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }

    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}

.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>
